export default {
    title: {
        USER_ALREADY_HAS_ACCESS: 'Access already exists',
        invalidInvite: 'Invalid invite',
    },
    text: {
        USER_ALREADY_HAS_ACCESS: 'The user already has this access. Return to the login screen.',
        invalidInvite: 'The invite used has been invalidated. Request the sending of a new invite.',
    },
    button: 'Go to login'
}